import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

export const criminalChargesConvictions: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.CRIMINAL_CHARGES_CONVICTIONS,
  label: "Crime and criminal convictions",
  kind: HtsTopicKind.Suitability,
  narrativeFields: [
    "what the charge or offence was",
    "when it happened",
    "the circumstances",
    "how it was resolved (withdrawn, stayed, acquitted, convicted, or still pending/awaiting court)",
    "what the candidate learned",
  ],
  followUpTriggers: [
    'the answer is vague about the outcome (e.g. "it got dealt with")',
    "the timeline is unclear",
    "the explanation doesn't match the seriousness of the charge",
  ],
  hardBarrierFacts: [
    "an unpardoned conviction (record suspension not granted) — a hard barrier at most Canadian agencies",
    "anything involving violence, dishonesty, weapons, or minors, regardless of how it was resolved",
    "impaired driving confirmed to have occurred within the last five years",
  ],
  crossCuttingNotes: [
    "impaired driving is at minimum a standard flag once ever disclosed — only escalate to the hard-barrier five-year threshold above once the timing is actually confirmed",
    "a criminal offence the candidate was never caught or charged for follows the same shape — follow-up on nature and timing, then human review, high priority if serious",
    "a charge still pending in court (no verdict yet) that doesn't fall under the violence/dishonesty/weapons/minors hard barrier above is not a hard barrier on its own, and is never fully resolved no matter how honestly it's disclosed — flag it for human review once the pending status is confirmed, and don't keep probing for an outcome that doesn't exist yet",
  ],
};
